<div class="subBlockContainer">
  <div class="subBlockContent" id="manageWGSsubscription">
    <child-header [title]="'Manage WatchGuard Subscription'" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">
          <form [formGroup]="wgsSubscriptionForm">
            <!-- <ng-container>
              <div class="my-4">
                <h6>SUBSCRIPTION DETAILS</h6>
                <div class="my-4" *ngIf="!commonService.isEmpty(detail)">
                  
                  <div class="my-2">DESC :  <span class="red-bold">{{detail?.invoiceSkuDescription}}</span></div>

                  <div class="my-2">BILLING START :  <span class="red-bold">{{detail?.termBillingStartDate | date: 'dd/MM/yyyy' }}</span></div>

                  <div class="my-2">BILLING END :  <span class="red-bold">{{detail?.termBillingEndDate | date: 'dd/MM/yyyy' }}</span></div>

                  <div class="my-2">SUBSCRIPTION CONTRACT ID :  <span class="red-bold">{{detail?.subscriptionContractId}}</span></div>

                  <div class="my-2">STOCK CODE :  <span class="red-bold">{{detail?.serviceSku}}</span></div>

                  <div class="my-2">TOTAL MONTHLY TERM :  <span class="red-bold">{{detail?.termInMonths}}</span></div>

                  <div class="my-2">REMAINING MONTHLY TERM :  <span class="red-bold">{{detail?.remainingInvoicesForTerm}}</span></div>
    
                </div>

                <div class="my-4" *ngIf="commonService.isEmpty(detail)">
                  <mat-spinner style="margin: auto;" mode="indeterminate"
                    class="circle" diameter="20">
                  </mat-spinner>
                </div>
              </div>
              <hr>
            </ng-container> -->

            <!-- manage service -->
            <ng-container>

              <h6>MANAGE SERVICE</h6>

              <div class="my-4">
                <div style="display: inline-flex;">
                  <span> <span class="highlight-text">Service Billing End Date: </span> {{detail?.termBillingEndDate | date: 'dd/MM/yyyy' }} </span>
                  <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                    class="circle cSPCustomerEntitlements-loading" diameter="20"
                    *ngIf="showSerialSpinner">
                  </mat-spinner>
                </div>
              </div>

              <div>
                <span>This will cancel the service at the end of the current term.</span>
              </div>

              <div class="my-4">
                <div style="display: inline-flex;">
                  <span class="highlight-text">SERVICE STATUS: &nbsp;&nbsp;</span><span>{{ detail?.subscriptionStatus }}</span>
                  <button
                    *ngIf="detail?.subscriptionStatus == 'Active'"
                    class="button button-red add-serial-btn"
                    style="border-radius: 30px;"
                    [disabled]="disableStatusButton"
                    (click)="cancelSubscription()">
                    Cancel
                  </button>
                  <!-- <mat-slide-toggle
                    style="margin-top: -4px;"
                    formControlName="status"
                    (change)="toggleStatusHandler()"
                    class="activesuspend mx-4">
                  </mat-slide-toggle> -->
                  <!-- <span> <span class="highlight-text"></span> Current status: {{ detail?.subscriptionStatus }}</span> -->
                  <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                    class="circle cSPCustomerEntitlements-loading" diameter="20"
                    *ngIf="showStatusToggleSpinner">
                  </mat-spinner>
                </div>
              </div>

              <div class="my-4">
                <div style="display: inline-flex;">
                  <span>
                    <span class="highlight-text">Serial No.:&nbsp;&nbsp; </span>
                    <input aria-label="Serial" class="align-center input-wrapper" style="height: 23px;" formControlName="serial">
                  </span>
                  <button class="button button-red add-serial-btn" style="border-radius: 30px;" (click)="addSerial()">{{detail?.serialNumber ? 'Update' : 'Add Serial' }}</button>
                  <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                    class="circle cSPCustomerEntitlements-loading" diameter="20"
                    *ngIf="showSerialSpinner">
                  </mat-spinner>
                </div>
              </div>
              
              <!-- </div> -->
            </ng-container>

          </form>
        </div>

      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
